const INITIAL_STATE = {
	dados: {},
	loading: false,
	error: null,
};

// eslint-disable-next-line default-param-last
export function clientTransacoes(state = INITIAL_STATE, action) {
	switch (action.type) {
		case '@clientTransacoes/REQUEST':
			return { ...state, loading: true };

		case '@clientTransacoes/SUCCESS':
			return {
				dados: { ...action.payload.dados },
				loading: false,
				error: null,
			};

		case '@clientTransacoes/FAILURE':
			return {
				dados: {},
				loading: false,
				error: action.payload.error,
			};

		default:
			return state;
	}
}
